<div class="generic-modal-root">  
    <div class="row-padding">
      <div class="row" style="margin-top: 0;" *ngIf="form">
        <form
          [formGroup]="form"
          class="m-form m-form--fit m-form--label-align-right"
        >
          <div style="border-bottom: 1px grey solid;" class="form-group m-form__group row">
            <label style="font-size: 30px;"> Change Sort Order </label>
          </div>
          <div class="form-group m-form__group row">
            <label style="text-align: left;">This value determines the order in which this Campaign will appear in the portal, as well as the order it appears on the customer-facing website.</label>
          </div>

          <div style="border-bottom: 1px grey solid;" class="form-group m-form__group row">
            <label class="col-lg-4 col-form-label">
                Sort Order:
            </label>
            <select
                formControlName="sortOrder"
                name="sortOrder"
                class="form-control m-input"
                style="width: auto;"
              >
                <option value="0">-- Select a Sort Order --</option>
                <option 
                  *ngFor="let item of counter; let i = index;"
                  [value]="i + 1"
                  [selected]="this.form.controls.sortOrder === i + 1"
                >
                  {{i + 1}}
                </option>
							</select>
            <app-validation-display
                [control]="form.controls.sortOrder"
                errorMessage="Please enter in a valid sort order greater than 0."
            ></app-validation-display>
          </div>
  
          <div style="display: flex; justify-content: space-between; margin-top: 20px;">
            <button
              [debounceClick]
              (click)="saveAndClose(true)"
              class="btn btn-success"
              style="margin:10px; float:right"
            >
              Update
            </button>
            <button
              (click)="close()"
              class="btn btn-success"
              style="margin:10px; float:right"
            >
              Close
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>